import { useEffect, useState } from 'react';
import { Account, Segment } from '../../interfaces/accounting.interface';
import { BankAccount } from '../../interfaces/bank/bankAccount.interface';
import { AccountService } from '../../services/account.service';
import { BankAccountService } from '../../services/bankAccount.service';
import { SegmentService } from '../../services/segment.service';
import { postingAccounts } from '../../utils/accountHierarchy';

/** Pickers shared by the facility form and the drawdown / repayment dialogs. Failures degrade to empty lists. */
export function useFinancingLookups(institutionId: string) {
  const [accounts, setAccounts] = useState<Account[]>([]);
  const [bankAccounts, setBankAccounts] = useState<BankAccount[]>([]);
  const [segments, setSegments] = useState<Segment[]>([]);
  useEffect(() => {
    let alive = true;
    (async () => {
      const [a, b, s] = await Promise.all([
        AccountService.getAllAccounts().catch(() => [] as Account[]),
        BankAccountService.listByInstitution(institutionId).catch(() => [] as BankAccount[]),
        SegmentService.getByInstitution(0, 200).catch(() => ({ content: [] as Segment[] })),
      ]);
      if (!alive) return;
      setAccounts(postingAccounts(a ?? []));
      setBankAccounts(b ?? []);
      setSegments(s?.content ?? []);
    })();
    return () => { alive = false; };
  }, [institutionId]);
  return { accounts, bankAccounts, segments };
}
